
import { useSelector } from 'react-redux';
import ArchiveIcon from '../assets/images/icons/archive.svg';
import DuplicateIcon from '../assets/images/icons/duplicate.svg';
import EditIcon from '../assets/images/icons/edit.svg';
import ReportIcon from '../assets/images/icons/report.svg';
import SampleIcon from '../assets/images/icons/sample.svg';
import { Button } from 'primereact/button';
import { Image } from 'primereact/image';
import { DEMAND, DEMAND_PARTNER, ROUTES, SUPPLY, SUPPLY_PARTNER } from '../assets/const/reportTypeConst';
import { useNavigate } from 'react-router-dom';
import { patchRequest } from '../assets/helper/ApiHandler';
import { Toast } from 'primereact/toast';
import { useRef } from 'react';
import { getReportPageUrlByType } from './pageUrls/urls';
import moment from 'moment';
import getRequest from '../assets/helper/ApiHandler';
import { useState } from 'react';
// import csvParser from 'papaparse';
import { Dialog } from 'primereact/dialog';
import { useDispatch } from 'react-redux';
import { setNotificationsState } from '../redux/sampleRedux';

export const ActionBttonColumn = ({ rowData, type, handleDuplicateRow, onArchiveChange }) => {

    const navigate = useNavigate();
    const toast = useRef(null);
    const filters = useSelector(state => state.filters.currentFilters);
    const options = { position: 'top', mouseTrack: true, mouseTrackTop: 15 };
    const [dates, setDates] = useState({
        startDate: useSelector(state => state.dateRange.startDate),
        endDate: useSelector(state => state.dateRange.endDate)
    });
    const [downloadingSample, setDownloadingSample] = useState(false)
    const dispatch = useDispatch();

    const handleEditClick = (row) => {
        let url = "/";
        switch (type) {
            case SUPPLY_PARTNER:
                url = '/supply-partner/edit/' + row.id;
                break;
            case SUPPLY:
                url = '/supply/edit/' + row.id;
                break;
            case DEMAND_PARTNER:
                url = '/demand-partner/edit/' + row.id;
                break;
            case DEMAND:
                url = '/demand/edit/' + row.id;
                break;
            case ROUTES:
                url = '/routes/edit/' + row.id;
                break;
            default:
                break;
        }
        navigate(url);
    }

    const handleReportButtonClick = (row) => {
        let route = getReportPageUrlByType(type)
        navigate(route, { state: { rowData: row } });
    };

    const handleArchiveClick = async (row, flag) => {
        let url = "";
        let id = null;
        switch (type) {
            case SUPPLY:
                id = row.id;
                url = `/supplies/${id}`;
                break;
            case DEMAND:
                id = row.id;
                url = `/demands/${id}`;
                break;
            case ROUTES:
                id = row.id;
                url = `/supply-to-demand-filters/${id}`;
                break;
            default:
                break;
        }
        updateArchiveApi(url, id, flag);
    }

    const updateArchiveApi = async (url, id, flag) => {
        let payload = {
            id: id,
            isArchived: flag
        };
        onArchiveChange(id, flag);
        try {
            let res = await patchRequest(url, payload, navigate);
            if (res.status === 200) {
                if (toast.current) {
                    toast.current.show({ severity: "success", summary: 'Success', detail: 'Row Archived successfully' });
                }
            }
        } catch (error) {
            onArchiveChange(id, flag);
            if (toast.current) {
                toast.current.show({ severity: "error", summary: 'Error', detail: error.message });
            }
        }
    }

    const handleSampleButtonClick = async (type, startDate, endDate, rowData) => {
        let st = moment(startDate).format("YYYY-MM-DD");
        let ed = moment(endDate).format("YYYY-MM-DD");
        let id = null;
        setDownloadingSample(true)
        try {
            
            let url = '';
            console.log(type)
            switch (type) {
                case SUPPLY:
                    id = rowData.id
                    url = `/sample/supply?startDate=${st}&endDate=${ed}&sid=${id}`
                    break;
                case DEMAND:
                    id = rowData.id
                    url = `/sample/demand?startDate=${st}&endDate=${ed}&did=${id}`
                    break;
                case ROUTES:
                    id = rowData.id
                    url = `/sample/routes?startDate=${st}&endDate=${ed}&sdid=${id}`
                    break;
                default:
                    throw new Error('Invalid tab selected.');
            }

            const reportingData = await getRequest(url, null, navigate);
            fetchNotifications();
        } catch (error) {   
            if (toast.current) {
                toast.current.show({ severity: "error", summary: 'Error', detail: error.message });
            }
        }
    };

    const fetchNotifications = async () => {
        try {
            const res = await getRequest(`/notifications`, null, navigate);
            console.log(res);
            dispatch(setNotificationsState(res));
        } catch (error) {
            console.error('Error fetching notifications:', error);
        }
    };
    

    const headerElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="fs-1 white-space-nowrap">Download Samples</span>
        </div>
    );

    const footerContent = (
        <div>
            <Button label="Close" className='button-style-2' onClick={() => setDownloadingSample(false)} autoFocus />
        </div>
    );

    return (
        <div className="actionBtn flex justify-content-center">
            <Toast ref={toast} position="bottom-right"></Toast>
            {
                filters.isArchived?.value.includes(true) ?
                    <Button link onClick={() => handleArchiveClick(rowData, false)} tooltip="UnArchive" tooltipOptions={options}>
                        <Image src={ArchiveIcon} alt="Image" width="15" />
                    </Button>
                    :
                    <>
                        <Button link onClick={() => handleEditClick(rowData)} tooltip="Edit" tooltipOptions={options}>
                            <Image src={EditIcon} alt="Image" width="15" />
                        </Button>
                        <Button link onClick={() => handleDuplicateRow(rowData)} tooltip="Duplicate" tooltipOptions={options}>
                            <Image src={DuplicateIcon} alt="Image" width="15" />
                        </Button>
                        {
                            type === SUPPLY_PARTNER || type === DEMAND_PARTNER ? null
                                :
                                <Button link onClick={() => handleArchiveClick(rowData, true)} tooltip="Archive" tooltipOptions={options}>
                                    <Image src={ArchiveIcon} alt="Image" width="15" />
                                </Button>

                        }
                        <Button link onClick={() => handleReportButtonClick(rowData)} tooltip="Report" tooltipOptions={options} >
                            <Image src={ReportIcon} alt="Image" width="15" />
                        </Button>
                        {
                            type === SUPPLY_PARTNER || type === DEMAND_PARTNER ? null 
                            :
                        <Button link onClick={() => handleSampleButtonClick(type, dates.startDate, dates.endDate, rowData)} tooltip="Sample" tooltipOptions={options}>
                            <Image src={SampleIcon} alt="Image" width="15" />
                        </Button>
                        }
                    </>
            }
            <Dialog className='sample-dialog' visible={downloadingSample} modal header={headerElement} footer={footerContent} style={{ width: '360px' }} onHide={() => setDownloadingSample(false)}>
                <p className="fs-12-500">
                    Your request to download samples is being processed. Once the request is processed, you'll receive a notification and an email with the link to download the samples.
                </p>
            </Dialog>
        </div >
    );
};